import React, { useState, useEffect } from 'react'
import './exchange.css'

function Exchange() {

    const [exchange, setExchange] = useState([]);

    const fetchExchange = async () => {
        const url = `https://api.coingecko.com/api/v3/exchanges?per_page=100`;
        let data = await fetch(url);
        let parsedData = await data.json();
        console.log(parsedData);
        setExchange(parsedData);
    }

    useEffect(() => {
        fetchExchange();
    }, [])

    return (
        <div>
            <h1 id='exchange'>List Of Top 100 Exchanges</h1>

            <div className="row exchange_row">
                {exchange.map((element) => {
                    return (<>
                        <div className="card exchange_card" >
                            <img src={element.image} className="card-img-top exchange_img" alt="..." />
                            <div className="card-body exchange_body">
                                <h5 className="card-title exchange_title">{element.name}</h5>
                                <p className="card-text exchange_text">Rank : {element.trust_score_rank}</p>
                                <p className="card-text exchange_text">Trust Score : {element.trust_score}</p>
                                <p className="card-text exchange_text">24h Vol. BTC {element.trade_volume_24h_btc}</p>
                                <p className="card-text exchange_text">Established : {element.year_established ? element.year_established : "No Data"}</p>

                                <a href={element.url} className="btn btn-primary">Visit Site</a>
                            </div>
                        </div>

                    </>)
                })}
            </div>


            <div className="thead">
                <tr>
                    <th>Rank</th>
                    <th>Name</th>
                    <th>Exchange Score</th>
                    <th>Volume(24h) BTC</th>
                    <th>Year Established</th>
                    <th>URL</th>
                </tr>
            </div>



            <div className="box">
                {exchange.map((element) => {
                    return (<>

                        <tr className='exchange_data'>
                            <td>{element.trust_score_rank}</td>
                            <img className='exchange_image' src={element.image} />
                            <td>{element.name}</td>
                            <td>{element.trust_score}</td>
                            <td>{element.trade_volume_24h_btc}</td>
                            <td>{element.year_established ? element.year_established : "No Data"}</td>
                            <td><button id='url_btn'><a href={element.url}>Visit</a></button></td>
                        </tr>

                    </>)
                })}
            </div>

        </div>
    )
}

export default Exchange